(function (Drupal) {
  Drupal.behaviors.halifax_sticky_nav = {
    attach() {
      let navHeight = 108;
      let scrolling = false;

      // Elements we are updating.
      const wrapper = document.getElementById('sticky-wrapper');
      const navbar = document.getElementsByClassName('hrm-navbar-wrapper');

      // Get Destination Halifax link on small screens.
      const destHfx = document.querySelector('.c-destination-halifax');

      // Get first alert banner wrapper.
      const alertBanner = document.querySelector(
        '.block-hrm-alerts-banner-custom-block'
      );

      // Get the admin toolbar using mod id and trays.
      const toolbar = document.getElementById('toolbar-bar');
      const toolbarTab = document.querySelector(
        '.toolbar .toolbar-bar .toolbar-tab:last-of-type'
      );
      const toolbarTrays = document.getElementsByClassName('toolbar-tray');
      const toolbarFixed = document.getElementsByClassName('toolbar-fixed');
      const toolbarOpen = document.getElementsByClassName('toolbar-tray-open');

      // Function to unstick the navbar.
      const unstickNavbar = function () {
        wrapper.classList.remove('navbar-wrapper--sticky');
        wrapper.style.height = null;
        navbar[0].style.left = null;
        navbar[0].style.position = null;
        navbar[0].style.right = null;
        navbar[0].style.top = null;
      };

      // Make header sticky if we have moved away from the top of the page.
      document.addEventListener('scroll', function () {
        if (!scrolling) {
          window.requestAnimationFrame(function () {
            let alertOffset = 0;
            let destHfxOffset = 0;

            // If there is an alert banner we have special considerations.
            if (!!alertBanner && alertBanner.offsetHeight > 0) {
              alertOffset = alertBanner.offsetHeight;
            }

            // Destination Halifax link for small screens.
            if (!!destHfx && destHfx.offsetHeight > 0) {
              destHfxOffset = destHfx.offsetHeight;
            }

            if (window.pageYOffset > 1 + alertOffset + destHfxOffset) {
              let navOffset = 0;
              let navLeft = 0;

              // Some logic to shift the sticky menu down when admin toolbar
              // or alert banner is present/open.
              if (toolbarFixed.length > 0) {
                // Is the admin tray open?
                if (toolbarOpen.length > 0) {
                  if (!!toolbarTab && toolbarTab.offsetHeight > 0) {
                    navOffset += toolbarTab.offsetHeight;
                  }

                  // If we have open trays.
                  if (toolbarTrays.length > 0) {
                    // Get active tray.
                    let activeToolbarTray = toolbarTrays[0];
                    for (let i = 0; i < toolbarTrays.length; i++) {
                      if (toolbarTrays[i].classList.contains('is-active')) {
                        activeToolbarTray = toolbarTrays[i];
                      }
                    }

                    // Horizontal.
                    if (
                      activeToolbarTray.classList.contains(
                        'toolbar-tray-horizontal'
                      ) &&
                      activeToolbarTray.offsetHeight > 0
                    ) {
                      navOffset += activeToolbarTray.offsetHeight;
                    }

                    // Vertical.
                    if (
                      activeToolbarTray.classList.contains(
                        'toolbar-tray-vertical'
                      ) &&
                      activeToolbarTray.offsetWidth > 0
                    ) {
                      navLeft += activeToolbarTray.offsetWidth;
                    }
                  }
                } else if (!!toolbar && toolbar.offsetHeight > 0) {
                  navOffset += toolbar.offsetHeight;
                }
              }

              // Helper for mobile header that is shorter than desktop.
              if (navbar[0].offsetHeight < navHeight) {
                navHeight = navbar[0].offsetHeight;
              }

              // If the navHeight is less than quarter of the viewport height
              if (navHeight < window.innerHeight / 4) {
                // Apply offset for positioning.
                wrapper.classList.add('navbar-wrapper--sticky');
                wrapper.style.height = `${navHeight}px`;
                navbar[0].style.left = `${navLeft}px`;
                navbar[0].style.position = 'fixed';
                navbar[0].style.right = '0px';
                navbar[0].style.top = `${navOffset}px`;
              } else {
                // unstick the navbar to leave room for content.
                unstickNavbar();
              }
            } else {
              unstickNavbar();
            }
            scrolling = false;
          });

          scrolling = true;
        }
      });
    },
  };
})(Drupal);
